/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon32Regular = forwardRef('MediaUiAPlayForwardIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8 6a1 1 0 0 0-2 0v20a1 1 0 1 0 2 0V6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.866 5.425C14.203 4.341 12 5.534 12 7.52v16.962c0 1.985 2.203 3.178 3.866 2.094l13.004-8.48c1.512-.987 1.512-3.203 0-4.189l-13.004-8.48ZM14 7.52a.5.5 0 0 1 .773-.419l13.004 8.481a.5.5 0 0 1 0 .838l-13.004 8.48a.5.5 0 0 1-.773-.418V7.519Z" })));
});
